export const isLive = true;

export const liveUrl = "https://api.hypegrow.io/Hypegrow-backend/public";
export const localUrl = "http://127.0.0.1:8000";
export const FILE_URL = isLive ? liveUrl : localUrl;
export const BASE_URL = isLive ? liveUrl + "/api/" : localUrl + "/api/";
